import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';

import type { ThemeColors } from '@/domain/models/theme.js';
import { ThemePaletteEditor } from '@/presentation/components/theme-palette-editor/theme-palette-editor.js';
import { useApp } from '@/presentation/hooks/use-app.js';

export { areThemeColorsValid } from '@/presentation/components/theme-palette-editor/theme-palette-editor.js';

type Props = {
    enabled: boolean;
    colors: ThemeColors;
    onEnabledChange: (enabled: boolean) => void;
    onColorsChange: (colors: ThemeColors) => void;
    readOnly?: boolean;
};

export function ClientThemeSection({ enabled, colors, onEnabledChange, onColorsChange, readOnly = false }: Props) {
    const { translate } = useApp();

    return (
        <Card variant="outlined" sx={{ borderRadius: 2, borderColor: 'divider', boxShadow: 1 }}>
            <CardContent sx={{ p: 3, '&:last-of-type': { pb: 3 } }}>
                <Typography variant="subtitle1" fontWeight={600} color="text.primary">
                    {translate('clients.theme.title')}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {translate('clients.theme.description')}
                </Typography>
                <FormControlLabel
                    control={<Switch checked={enabled} onChange={(event) => onEnabledChange(event.target.checked)} disabled={readOnly} />}
                    label={translate('clients.theme.customize')}
                    sx={{ mb: enabled ? 2 : 0 }}
                />
                {enabled && (
                    <Box sx={readOnly ? { pointerEvents: 'none', opacity: 0.6 } : undefined}>
                        <ThemePaletteEditor colors={colors} onColorsChange={onColorsChange} />
                    </Box>
                )}
            </CardContent>
        </Card>
    );
}
